import React, { useState, useEffect } from 'react'
import Topbar from '../mini-comp/Topbar'
import Sidebar from '../mini-comp/Sidebar'
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';
import { FaEye } from 'react-icons/fa'
import { RiUserLine } from 'react-icons/ri'
import Swal from 'sweetalert2';

const EmployeeNotices = () => {
    const [notices, setNotices] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const fetchNotices = async () => {
        try {
            const token = Cookies.get('token');
            const response = await axios.get(`${API_BASE_URL}/api/v1/notices/`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            setNotices(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching notices:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchNotices();
    }, []);

    const handleMarkAsRead = async (id) => {
        try {
            const token = Cookies.get('token');
            await axios.post(`${API_BASE_URL}/api/v1/notices/${id}/mark-read/`, {}, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            Swal.fire({
                title: 'Success!',
                text: 'Notice marked as read',
                icon: 'success',
                timer: 1500,
                showConfirmButton: false
            });
            fetchNotices();
        } catch (error) {
            console.error('Error marking notice as read:', error);
            Swal.fire('Error!', 'Failed to mark notice as read.', 'error');
        }
    };

    const getRecipientLabel = (notice) => {
        if (notice.recipient_type === 'all') return 'All Employees';
        if (notice.recipient_type === 'department') return 'Department';
        if (notice.recipient_type === 'individual') return 'Selected Employees';
        return notice.recipient_type;
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    return (
        <div>
            <Topbar />
            <Sidebar />

            <div className="app-content-area">
                <div className="app-content-wrap">
                    <div className="container-fluid">
                        <div className="row">
                            {loading ? (
                                <div className="col-12 text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            ) : notices.length > 0 ? (
                                notices.map((notice) => (

                                    <div key={notice.id} className="col-xxl-3 col-xl-6 col-lg-6 col-md-6 mb-4">
                                        <div className="card h-100">
                                            <div className="card-body d-flex flex-column">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <span className={`badge ${notice.recipient_type === 'all' ? 'bg-success' :
                                                        notice.recipient_type === 'department' ? 'bg-warning' : 'bg-info'
                                                        }`}>
                                                        {getRecipientLabel(notice)}
                                                    </span>
                                                    <div className="d-flex gap-2">
                                                        <button
                                                            className={`btn ${notice.is_read ? 'btn-secondary' : 'btn-primary'} btn-sm d-flex align-items-center justify-content-center`}
                                                            onClick={() => handleMarkAsRead(notice.id)}
                                                            title={notice.is_read ? "Already Read" : "Mark as Read"}
                                                            disabled={notice.is_read}
                                                        >
                                                            {notice.is_read ? 'Read' : 'Mark as Read'}
                                                        </button>
                                                    </div>
                                                </div>

                                                <div className="mb-3">
                                                    <small className="text-muted">{formatDate(notice.created_at)}</small>
                                                    <h5 className="card-title mt-1">{notice.title}</h5>
                                                </div>

                                                <p className="card-text mb-4 text-truncate-3" style={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden'
                                                }}>
                                                    {notice.content}
                                                </p>

                                                <div className="d-flex justify-content-between align-items-center mb-4">
                                                    <div className="d-flex-items gap-5">
                                                        <span className="d-block text-success fw-bold">{notice.read_count || 0}</span>
                                                        <FaEye className="blink text-success" />
                                                    </div>
                                                    <small className="text-muted">
                                                        Sent to: {
                                                            notice.recipient_type === 'all' ? 'Everyone' :
                                                                notice.recipient_type === 'department' ? (notice.department_name || 'Department') :
                                                                    `${notice.recipients_detail?.length || 0} Employee(s)`
                                                        }
                                                    </small>
                                                </div>

                                                <hr />
                                                <div className="project-team-wrapper mt-auto">
                                                    <div className="d-flex-between">
                                                        {notice.recipient_type === 'individual' && (
                                                            <div className="project-team">
                                                                <span className="d-block fw-5 text-black mb-10">Target Employees:</span>
                                                                <div className="avatar-group">
                                                                    {notice.recipients_detail?.slice(0, 5).map((recipient) => (
                                                                        <div key={recipient.id} className="avatar-group-item avatar">
                                                                            <a href="javascript:void(0);" data-bs-toggle="tooltip" data-bs-placement="top" title={`${recipient.full_name}`}>
                                                                                {recipient.photo ? (
                                                                                    <img className="radius-100" src={API_BASE_URL + recipient.photo} alt="recipient" />
                                                                                ) : (
                                                                                    <div className="radius-100 bg-light d-flex align-items-center justify-content-center h-100 w-100 border">
                                                                                        <RiUserLine size={30} className="text-primary" />
                                                                                    </div>
                                                                                )}
                                                                            </a>
                                                                        </div>
                                                                    ))}
                                                                    {notice.recipients_detail?.length > 5 && (
                                                                        <div className="avatar-group-item avatar bg-primary text-white fs-12 fw-6 d-flex align-items-center justify-content-center">
                                                                            +{notice.recipients_detail.length - 5}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="col-12 text-center py-5">
                                    <div className="card p-5">
                                        <h5>No notices found</h5>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default EmployeeNotices
